import { HomeDashboard } from "@/components/HomeDashboard";

const Home = () => {
  return <HomeDashboard />;
};

export default Home;


